import {useContext} from "react";
import {AuthContext} from "../providers/context";

export default function useAuth() {
    return useContext(AuthContext)
}